import { enableProdMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MncSDoHModule } from '@app/mnc-sdoh.module';
import { environment } from '@env/environment';

if (environment.production) {
  enableProdMode();
}

const { buildNumber, commit } = environment.version;

console.log('SDOH UI Version:', {
  buildNumber,
  commit,
})

platformBrowserDynamic()
  .bootstrapModule(MncSDoHModule, {
    applicationProviders: [
      provideZoneChangeDetection()],
      providers: [{ provide: LOCALE_ID, useValue: 'en-US' }],
    })
  .catch((err) => console.error(err));
